// CONSTANTS are all caps.
const NS = 'TeleCareExistingCustomerFormPage';
const CLS = 'teleCareExistingCustomerFormPage';
const PG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadPg.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import vivalid from 'vivalid';
import * as utils from '../../../../global/js/utils';

export class TeleCareExistingCustomerFormPage {
	// TODO: confirm form submission details
	// How will show/hide of customer details section affect the form when submitting data
	constructor($el) {
		// $el is the page node return by the loadTeleCareExistingCustomerFormPage function
		this.$el = $el;
	}

	init() {
		this.setTeleCareExistingCustomerFormPage();
		this.setFormValidation();
	}

	setTeleCareExistingCustomerFormPage() {
		// Add Some logic here
		if ($('#radioOther').prop('checked')) {
			$(PG + 'customerDetailsContainer').show();
		} else {
			$(PG + 'customerDetailsContainer').hide();
		}

		$('.alarmEnquiry').on('click', function() {
			// reset validation
			$('.reset-form-validation').trigger('click');

			let val = $(this).val();
			if (val === 'mine') {
				$(PG + 'customerDetailsContainer').hide();
			} else {
				$(PG + 'customerDetailsContainer').show();
			}
    });
  }

	// Add more functions like on above here
	setFormValidation() {
		let $pg = $(this.$el);
		utils.formValidationRules();

		let addCallback = vivalid.htmlInterface.addCallback;
		let initAllValidations = vivalid.htmlInterface.initAll;

		addCallback('onValidationSuccess', () => {
			let $form = $pg.find('form');
			$('.loading-spinner').addClass('is-active');
      // eslint-disable-next-line no-undef
      grecaptcha.ready(function() {
        // eslint-disable-next-line no-undef
        grecaptcha.execute('6Lfp5PooAAAAAD_AMAUIzJ4TWqpOGmSCsg6ZpsZu', {action: 'BuyStJohnTelecareExistingCustomerEnquiry'}).then(function(token) {
          // Add your logic to submit to your backend server here.

          let recaptcha = token;
          let recaptchaErr = $form.find('#recaptcha-error');
          if (!recaptcha || recaptcha === '') {
            // error div for recpatcha
            recaptchaErr.removeClass('d-none');
            $pg.find('button[type="submit"]').prop('disabled', false);
          } else {
            $form.find('#CaptchaVerifyKey').val(recaptcha);
            recaptchaErr.addClass('d-none');
            $form[0].submit();
          }
        });
      });
		});
		addCallback('onValidationFailure', (invalid, pending, valid) => {
      let popUpErrorMessage = $('#pop-up-err-msg').val();
      alert(popUpErrorMessage);
    });

		initAllValidations();
	}
}



// WEBPACK FOOTER //
// C:/Users/GavinDow/source/repos/FrontEndWebsite/src/views/pages/telecareExistingCustomerFormPage/js/teleCareExistingCustomerFormPage.js